import { Check, Minus } from "lucide-react";
import { WHY_INDIA, COMPARE } from "@/data/content";
import { Reveal, MaskedLines, Eyebrow } from "./Reveal";

const Compare = () => (
  <Reveal delay={0.1} data-testid="why-india-compare" className="mt-24 overflow-hidden rounded-[2rem] border border-brand-indigo/10 bg-brand-ice">
    <div className="grid grid-cols-3 border-b border-brand-indigo/10 px-6 py-5 font-mono text-[10px] uppercase tracking-[0.25em] text-brand-indigo/60 sm:px-10">
      <span>The decision</span>
      <span>{COMPARE.cols[0]}</span>
      <span className="text-brand-indigo">{COMPARE.cols[1]}</span>
    </div>
    {COMPARE.rows.map(([label, local, remote], i) => (
      <div key={label} data-testid={`compare-row-${i + 1}`} className="group grid grid-cols-3 gap-4 border-b border-brand-indigo/10 px-6 py-6 transition-colors duration-300 last:border-b-0 hover:bg-white sm:px-10">
        <div className="font-display text-sm font-semibold text-brand-ink sm:text-base">{label}</div>
        <div className="flex items-start gap-2 text-sm text-slate-500">
          <Minus className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" />
          <span>{local}</span>
        </div>
        <div className="flex items-start gap-2 text-sm font-medium text-brand-ink">
          <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-cyan" />
          <span>{remote}</span>
        </div>
      </div>
    ))}
  </Reveal>
);

export const WhyIndia = () => (
  <section id="why-india" data-testid="why-india-section" className="bg-white py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Reveal><Eyebrow n="04" label="Remote hiring & outsourcing" /></Reveal>
          <MaskedLines
            as="h2"
            inView
            delay={0.1}
            className="mt-6 font-display text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl lg:text-5xl"
            lines={["Why building your team", "remotely, in India, makes sense."]}
          />
        </div>
        <Reveal delay={0.2} className="lg:col-span-5">
          <p className="text-base leading-relaxed text-slate-600 md:text-lg">
            Every US practice and promo business needs specialists it can't easily hire, afford or keep busy full-time.
            A managed remote team removes that constraint — without lowering the bar on quality or compliance.
          </p>
        </Reveal>
      </div>

      <div className="mt-20 grid gap-x-12 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
        {WHY_INDIA.map((w, i) => (
          <Reveal key={w.n} delay={0.06 * i} data-testid={`why-india-point-${i + 1}`} className="border-t border-brand-indigo/10 pt-8">
            <div className="font-mono text-xs tracking-[0.25em] text-brand-cyan">{w.n}</div>
            <h3 className="mt-4 font-display text-xl font-semibold tracking-tight text-brand-ink sm:text-2xl">{w.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">{w.body}</p>
          </Reveal>
        ))}
      </div>

      <Compare />
    </div>
  </section>
);
